import { exceedsDepth } from './depth';

/** Minimum discount depth (as fraction) for a vendor-day to be on promotion; CONTEXT.md On-promotion owns the definition, ruling 2026-10-16. */
export const PROMO_THRESHOLD = 0.1;

/** True when a depth already computed as a fraction strictly exceeds PROMO_THRESHOLD, exactly 10 percent excluded. */
export function isPromoDepth(depth: number | null | undefined): boolean {
  return depth != null && exceedsDepth(depth, PROMO_THRESHOLD);
}

/** Depth of price under regularPrice as a fraction; null unless both are positive, zero or negative when price is at or above it. */
export function discountDepth(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): number | null {
  if (price == null || regularPrice == null || price <= 0 || regularPrice <= 0) return null;
  return (regularPrice - price) / regularPrice;
}

/** discountDepth in percent (0-100). */
export function discountDepthPercent(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): number | null {
  const depth = discountDepth(price, regularPrice);
  return depth === null ? null : depth * 100;
}

/** True when the depth strictly exceeds PROMO_THRESHOLD (CONTEXT.md, On-promotion). */
export function isOnPromotion(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): boolean {
  return isPromoDepth(discountDepth(price, regularPrice));
}
